var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 12.6711 18.9598 15.1823 17.0711 17.0711C15.1823 18.9598 12.6711 20 10 20C8.13012 20 6.33895 19.4896 4.78445 18.5359L5.93094 17.3894C7.13836 18.0569 8.52547 18.4375 10 18.4375C14.6525 18.4375 18.4375 14.6525 18.4375 10C18.4375 8.52547 18.0569 7.13836 17.3893 5.93098L18.5359 4.78449C19.4896 6.33895 20 8.13012 20 10ZM1.13836 19.9665L0.0335156 18.8616L2.39789 16.4973C0.846367 14.6877 0 12.4089 0 10C0 7.32891 1.0402 4.8177 2.92891 2.92891C4.8177 1.0402 7.32891 0 10 0C12.4089 0 14.6877 0.846367 16.4973 2.39789L18.8616 0.0335156L19.9665 1.13836L1.13836 19.9665ZM3.50988 15.3852L15.3852 3.50988C13.9231 2.29449 12.0455 1.5625 10 1.5625C5.34754 1.5625 1.5625 5.34754 1.5625 10C1.5625 12.0455 2.29445 13.9231 3.50988 15.3852Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoColor);
export default __webpack_public_path__ + "static/media/NoColor.3d75a177d9c79f8deb65af23a028bb57.svg";
export { ForwardRef as ReactComponent };